export default __webpack_public_path__ + "media/zurb/img/events/wired/life-services-image3-b26c6f3810724d7e2ac6028779babd49.png";